import {useDispatch, useSelector} from "react-redux";
import {backModal, hideModal, showModal, toggleModal} from "@/store/slices/modalSlice";
import {useEffect, useState} from "react";

export const useModal = (name) => {
    const [renderKey, setRenderKey] = useState(null);
    const isOpen = useSelector(state => state.modal.modals[name])
    const payload = useSelector(state => state.modal.payloads[name])
    const dispatch = useDispatch()

    useEffect(() => {
        if (isOpen === false) return;

        setRenderKey(Date.now())
    }, [isOpen]);

    const show = (data) => {
        dispatch(showModal({name, data}))
    }

    const hide = () => {
        dispatch(hideModal(name))
    }

    const set = (isOpen) => {
        if (isOpen) {
            show()
        }
        else {
            hide()
        }
    }

    const toggle = () => {
        dispatch(toggleModal(name))
    }

    const back = () => {
        dispatch(backModal(name))
    }

    return {
        isOpen,
        show,
        hide,
        toggle,
        back,
        set,
        payload,
        renderKey
    }
}